module.exports = __webpack_public_path__ + "static/media/grid_view_icon_grey.84a9bdac.svg";